import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["frame", "loading", "error", "unavailable"];

  checkResponse(event) {
    if (event.target !== this.frameTarget) return;

    const { fetchResponse } = event.detail;
    if (fetchResponse.redirected) {
      event.preventDefault();
      Turbo.visit(fetchResponse.location.href, { action: "replace" });
    } else if (!fetchResponse.succeeded) {
      event.preventDefault();
      const unavailable = [403, 404].includes(fetchResponse.statusCode) && this.hasUnavailableTarget;
      this.show(unavailable ? this.unavailableTarget : this.errorTarget);
    }
  }

  failed(event) {
    if (event.target !== this.frameTarget) return;

    if (event.type === "turbo:frame-missing") event.preventDefault();
    this.show(this.errorTarget);
  }

  retry() {
    this.show(this.loadingTarget);
    this.frameTarget.reload();
  }

  // A link inside the frame is removed by the navigation it starts, which drops
  // focus to the body. Turbo only restores focus to an element marked autofocus,
  // so a response without one lands focus on the frame instead, but only for a
  // navigation the user asked for and never for the initial load.
  expectFocus() {
    this.focusAfterRender = true;
  }

  rendered(event) {
    if (event.target !== this.frameTarget || !this.focusAfterRender) return;

    this.focusAfterRender = false;
    if (!this.frameTarget.querySelector("[autofocus]")) this.frameTarget.focus();
  }

  show(template) {
    this.frameTarget.replaceChildren(template.content.cloneNode(true));
  }
}
